import { Grid } from "@mui/material";
import React from "react";

const DashboardCard = (props) => {
    return(
        <Grid
            xs={12}
            sm={6}
            md={4}
            className={props.addClass + " OS---Dap-cards text-center py-5 px-3"}
        >
            <h6>{props.title}</h6>
            <h3 className="mb-0">{props.detail}</h3>
        </Grid>
    );
}

export default DashboardCard;